import { GetCurrentUserProjectPermissionsResponse } from "../../service/query";

// Looks up by project, or by group when no project is given.
export const hasPermissionForProject = (
  permissions: GetCurrentUserProjectPermissionsResponse[],
  projectUuid: string | undefined | null,
  permission: string,
  groupUuid?: string | null
): boolean => {
  return projectUuid
    ? (permissions.find((p) => p.projectUuid === projectUuid)?.currentUserPermissions.includes(permission) ?? false)
    : (permissions.find((p) => p.groupUuid === groupUuid)?.currentUserPermissions.includes(permission) ?? false);
};
